import { render, staticRenderFns } from "./FeaturesCoverItemListUpdate.vue?vue&type=template&id=66b5dac6"
import script from "./FeaturesCoverItemListUpdate.vue?vue&type=script&lang=js"
export * from "./FeaturesCoverItemListUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports